module.exports = __webpack_public_path__ + "img/illustration-cod-shipping-cost.8c8daca8.svg";